<template>
  <div>
    <el-upload
      ref="upload"
      action="/bohee/bop/api/system/syspoi/fileimport"
      :disabled="disabled"
      :file-list="file"
      :before-upload="before"
      :limit="1"
      :show-file-list="false"
      :data="jsonHeader"
      :headers="headers"
      accept=".xlsx"
      :on-success="clearFiles"
      :on-error="error"
    >
      <el-button size="small" type="primary" buttonCode="TY006" @click="sendFileImport" :disabled="disabled">{{name}}</el-button>
    </el-upload>
  </div>
</template>
<script>
export default {
  name: "fileImport",
  props: {
    value: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      default: "导入"
    },
    header: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      file: [],
      loading:""
    };
  },
  computed: {
    jsonHeader() {
      let header = Object.assign({}, this.header);
      let poiEntity = {
        poiEntity: JSON.stringify(header)
      };
      return poiEntity;
    },
    headers(){
      return{
        "Authorization":sessionStorage.getItem("Token")
      }
    }
  },
  methods: {
    before(file) {
      if (file.name.includes(".xlsx")) {
        
    
        this.loading = this.$loading({
          lock: true,
          text: '正在导入中.....',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      } else {
        this.$message.error("导入文件格式不正确,只支持.xlsx文件");
        return false;
      }
    },
    sendFileImport() {
      //按钮不禁用
      if (!this.disabled) {
        // this.loading = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // });
      }
    },
    clearFiles(res, file, fileList) {
      this.loading.close();
      if (res.code === "200") {
        this.$emit("input", res.body);
        this.$nextTick(()=>{
          this.$message.success("导入成功");
        })
      } else if (res.code === "400") {
        let errorMessage = res.body;
        errorMessage = errorMessage.replace("XX", res.message);
        this.$message({
          message: errorMessage,
          type: "error",
          duration: 6000
        });
      }
      this.$refs.upload.clearFiles();
    },
    error(err, file, fileList) {

    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-upload {
  display: inline !important;
  border: none;
}
</style>






// WEBPACK FOOTER //
// src/components/import/fileImport.vue